/**
 * Whether an agent_template is a survey: `survey`, or a variant of it (`…_survey`), as New campaign reads it. A survey
 * VoiceAgent makes calls (it has a Campaigns tab and a Results tab); every other agent_template answers them.
 *
 * Moved from the portal's `apps/web-app/src/routes/agents/[id]/agent-tabs.ts` (plan-034 VIEW-PKG), which re-exports it.
 */
export function isSurveyAgentTemplate(agentTemplateCode) {
    return agentTemplateCode === "survey" || agentTemplateCode.endsWith("_survey");
}
//# sourceMappingURL=survey-agent-template.js.map